(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React, { Fragment, createContext, useContext, useRef, useState } from 'react';
import ConfirmationDialog from "./ConfirmationDialog.js";
var ConfirmationServiceContext = createContext(Promise.reject);
export var useConfirmation = function useConfirmation() {
  return useContext(ConfirmationServiceContext);
};

__signature__(useConfirmation, "useContext{}");

export var ConfirmationServiceProvider = function ConfirmationServiceProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      confirmationState = _useState4[0],
      setConfirmationState = _useState4[1];

  var awaitingPromiseRef = useRef();

  var openConfirmation = function openConfirmation(options) {
    setConfirmationState(options);
    setOpen(true);
    return new Promise(function (resolve, reject) {
      awaitingPromiseRef.current = {
        resolve: resolve,
        reject: reject
      };
    });
  };

  var handleClose = function handleClose() {
    if (confirmationState.catchOnCancel && awaitingPromiseRef.current) {
      awaitingPromiseRef.current.reject();
    }

    setOpen(false);
  };

  var handleSubmit = function handleSubmit() {
    if (awaitingPromiseRef.current) {
      awaitingPromiseRef.current.resolve();
    }

    setOpen(false);
  };

  var handleClosed = function handleClosed() {
    setConfirmationState(null);
  };

  return React.createElement(Fragment, null, React.createElement(ConfirmationServiceContext.Provider, {
    value: openConfirmation
  }, children), React.createElement(ConfirmationDialog, _extends({
    open: open,
    onSubmit: handleSubmit,
    onClose: handleClose,
    onClosed: handleClosed
  }, confirmationState)));
};

__signature__(ConfirmationServiceProvider, "useState{[open, setOpen](false)}\nuseState{[confirmationState, setConfirmationState](null)}\nuseRef{awaitingPromiseRef}");

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ConfirmationServiceContext, "ConfirmationServiceContext", "/home/vsts/work/1/s/src/components/overlays/ConfirmationService.js");
  reactHotLoader.register(useConfirmation, "useConfirmation", "/home/vsts/work/1/s/src/components/overlays/ConfirmationService.js");
  reactHotLoader.register(ConfirmationServiceProvider, "ConfirmationServiceProvider", "/home/vsts/work/1/s/src/components/overlays/ConfirmationService.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();